import { z } from "zod";

export const TopicSchema = z.enum([
  "innovation",
  "persistence",
  "responsibility",
  "service",
  "growth",
  "uncertainty",
  "collaboration",
  "other",
]);

export const QuestionCardSchema = z.object({
  context: z.string().min(1).max(260),
  optionA: z.string().min(1).max(60),
  optionB: z.string().min(1).max(60),
});

export const QuestionAnalysisSchema = z.object({
  topic: TopicSchema,
  coreConflict: z.string().min(1).max(80),
  safeSummary: z.string().min(1).max(60),
  questionOne: QuestionCardSchema,
});

export const NextQuestionSchema = z.object({
  questionTwo: QuestionCardSchema,
});

export const ReflectionSchema = z.object({
  reflection: z.string().min(100).max(180),
  topic: TopicSchema,
  recommendedTheme: z.enum([
    "innovation",
    "persistence",
    "responsibility",
    "service",
    "growth",
    "collaboration",
    "other",
  ]),
});

export const ActionSchema = z.object({
  original: z.string().min(1).max(100),
  refined: z.string().min(1).max(40),
});

export const SessionRequestSchema = z.object({}).strict();

export const QuestionRequestSchema = z.object({
  sessionId: z.string().min(8).max(120),
  question: z.string().trim().min(5).max(20),
});

export const AnswerRequestSchema = z.object({
  sessionId: z.string().min(8).max(120),
  stage: z.literal(1),
  selectedOption: z.enum(["A", "B"]),
  topic: TopicSchema,
});

export const ResultRequestSchema = z.object({
  sessionId: z.string().min(8).max(120),
  originalQuestion: z.string().min(5).max(120),
  firstAnswer: z.string().min(1).max(120),
  secondAnswer: z.string().min(1).max(120),
  thirdAnswer: z.string().min(1).max(80),
});

export const ActionRequestSchema = z.object({
  sessionId: z.string().min(8).max(120),
  original: z.string().min(1).max(100),
});

export const CompleteRequestSchema = z.object({
  sessionId: z.string().min(8).max(120),
  topic: TopicSchema,
  journeyCompleted: z.literal(true),
  actionKeyword: z.enum(["灏濊瘯", "鍧氭寔", "鍊惧惉", "瀛︿範", "璐ｄ换", "鏀瑰彉", "鍚堜綔", "琛屽姩"]),
  caseId: z.string().max(80).nullable().optional(),
});

export const AnalyticsEventSchema = z.enum([
  "session_start",
  "journey_complete",
  "ai_success",
  "ai_fallback",
  "ticket_generated",
]);

export const EventRequestSchema = z.object({
  sessionId: z.string().min(8).max(120),
  event: AnalyticsEventSchema,
});

export type QuestionAnalysis = z.infer<typeof QuestionAnalysisSchema>;
export type NextQuestion = z.infer<typeof NextQuestionSchema>;
export type Reflection = z.infer<typeof ReflectionSchema>;
export type Action = z.infer<typeof ActionSchema>;

export const PUBLIC_CONTENT_STATUS = z.literal("published");
